import React from 'react';
import '../assets/css/BlogSkeleton.css';

const BlogSkeleton = () => {
  return (
    <div className="blog-skeleton">
      {/* Tag skeleton */}
      <div className="skeleton-tag"></div>
      
      {/* Title skeleton */}
      <div className="skeleton-title"></div>
      
      {/* Image skeleton */}
      <div className="skeleton-image"></div>
      
      {/* Description skeleton */}
      <div className="skeleton-description">
        <div className="skeleton-line"></div>
        <div className="skeleton-line"></div>
        <div className="skeleton-line short"></div>
      </div>
      
      {/* Meta info skeleton */}
      <div className="skeleton-meta">
        <div className="skeleton-meta-item"></div>
        <div className="skeleton-meta-item"></div>
        <div className="skeleton-meta-item"></div>
      </div>
    </div>
  );
};

export default BlogSkeleton;
